import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';
import { useComments } from '@/hooks/useComments';
import CommentHeader from './CommentHeader';
import CommentForm from './CommentForm';
import CommentsList from './CommentsList';
import { Comment as CommentType } from '@/utils/storiesData';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useIsMobile } from '@/hooks/use-mobile';
import YouTubeSubscribeBanner from './YouTubeSubscribeBanner';
interface CommentSectionProps {
  storyId: string;
  comments?: CommentType[];
}
const CommentSection: React.FC<CommentSectionProps> = ({
  storyId
}) => {
  const {
    user,
    signInWithGoogle,
    signOut
  } = useAuth();
  const {
    resolvedTheme
  } = useTheme();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const textColor = resolvedTheme === 'dark' ? 'text-white' : 'text-black';
  const borderColor = resolvedTheme === 'dark' ? 'border-white/10' : 'border-gray-200';
  const {
    comments,
    loading,
    comment,
    setComment,
    userLikes,
    handleCommentSubmit,
    handleLikeComment
  } = useComments(storyId, user);
  const handleLoginPrompt = async () => {
    toast.info("Sign in to join the conversation", {
      action: {
        label: "Sign In",
        onClick: () => navigate("/profile")
      }
    });

    // Return a resolved Promise to match the expected return type
    return Promise.resolve();
  };
  return <div id="comments" className="relative">
      <CommentHeader commentCount={comments.length} user={user} signInWithGoogle={signInWithGoogle} signOut={signOut} textColor={textColor} navigate={navigate} />

      {user && (
        <CommentForm comment={comment} setComment={setComment} handleCommentSubmit={handleCommentSubmit} user={user} />
      )}

      <CommentsList loading={loading} comments={comments} user={user} userLikes={userLikes} handleLikeComment={handleLikeComment} signInWithGoogle={user ? undefined : handleLoginPrompt} textColor={textColor} />
      
      {/* YouTube banner below comments on mobile */}
      {isMobile && (
        <div className="mt-6">
          <YouTubeSubscribeBanner />
        </div>
      )}
    </div>;
};
export default CommentSection;